<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.firstName"
        :validator="vs.form.firstName"
        :label="adminText('adminAll.first_name_7e568a', 'First name')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.lastName"
        :validator="vs.form.lastName"
        :label="adminText('adminAll.last_name_adec36', 'Last name')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.email"
        :disabled="true"
        :label="adminText('adminAll.email_84add5', 'Email')"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.password"
        :validator="vs.form.password"
        :label="adminText('adminAll.set_new_password_25c6fc', 'Set new password')"
        :error-messages="{ minLength: adminText('adminAll.password_must_have_atleast_5_characters_57da69', 'Password must have atleast 5 characters') }"
        type="password"
      />
    </v-flex>
  </v-layout>
</template>


<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'

export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'invite-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}

</script>

<style scoped>
</style>
